import { combineReducers } from 'redux';

import { RootState } from './types';
import localeReducer from './locale/reducer';
import productReducer from './product/reducer';
import authReducer from './auth/reducer';

const rootReducer = () => combineReducers<RootState>({
  locale: localeReducer(),
  product: productReducer(),
  auth: authReducer(),
});

export default rootReducer;
